document.addEventListener("DOMContentLoaded", () => {
    let secretCode = [];
    const easterEgg = ["ArrowUp", "ArrowUp", "ArrowDown", "ArrowDown", "ArrowLeft", "ArrowRight", "ArrowLeft", "ArrowRight", "b", "a"];

    document.addEventListener("keydown", (event) => {
        secretCode.push(event.key);
        secretCode = secretCode.slice(-easterEgg.length);

        if (JSON.stringify(secretCode) === JSON.stringify(easterEgg)) {
            showSecret();
        }
    });
});

function showSecret() {
    let secretDiv = document.getElementById("secret-message");
    if (!secretDiv) {
        createSecretMessage();
    }
    secretDiv = document.getElementById("secret-message");
    secretDiv.style.display = "block";
    setTimeout(() => {
        secretDiv.style.opacity = "1";
    }, 100);

    // Lecture du son
    let audio = new Audio("https://us-tuna-sounds-files.voicemod.net/14d74a45-3f83-423b-8593-0b46d7c44dc7-1664318763405.mp3");
    audio.play().catch(error => console.log("Lecture bloquée : ", error));
}

function createSecretMessage() {
    let div = document.createElement("div");
    div.id = "secret-message";
    div.style.position = "fixed";
    div.style.top = "50%";
    div.style.left = "50%";
    div.style.transform = "translate(-50%, -50%)";
    div.style.background = "rgba(0, 0, 0, 0.9)";
    div.style.color = "white";
    div.style.padding = "20px";
    div.style.borderRadius = "10px";
    div.style.display = "none";
    div.style.textAlign = "center";
    div.style.fontSize = "18px";
    div.style.zIndex = "1000";
    div.style.opacity = "0";
    div.style.maxWidth = "400px";
    div.style.transition = "opacity 0.5s ease-in-out";

    let p = document.createElement("p");
    p.innerHTML = `
        Bonjour à toi cheater ! Je suis <strong>Virgile Bronzi</strong>, concepteur du site.<br><br>
        Bravo, tu as trouvé le petit secret 😉.<br><br>
        Clin d'œil à ma sœur qui râlait de me voir utiliser des cheat codes partout quand nous étions enfants 😂.<br><br>
        J'espère que tu aimes le site et n'hésite pas à me faire part de tes retours à 
        <a href="mailto:v.bronzi@binary-edge.fr" style="color: #FFD700; text-decoration: underline;">v.bronzi@binary-edge.fr</a> !<br><br>
        Bonne navigation !<br><br> ⬇️ TOI ⬇️
    `;

    
    let img = document.createElement("img");
    img.src = "https://media1.tenor.com/m/TbTe1Nc6j34AAAAC/hacker-hackerman.gif"; 
    img.style.width = "100%";
    img.style.marginTop = "10px";
    img.style.borderRadius = "10px";

    let btn = document.createElement("button");
    btn.innerText = "Fermer";
    btn.style.marginTop = "10px";
    btn.style.padding = "8px 12px";
    btn.style.background = "red";
    btn.style.color = "white";
    btn.style.border = "none";
    btn.style.cursor = "pointer";
    btn.style.fontSize = "16px";
    btn.onclick = hideSecret;

    div.appendChild(p);
    div.appendChild(img);  
    div.appendChild(btn);
    document.body.appendChild(div);
}

function hideSecret() {
    let secretDiv = document.getElementById("secret-message");
    secretDiv.style.opacity = "0";
    setTimeout(() => {
        secretDiv.style.display = "none";
    }, 500);
}
